module.exports = __webpack_public_path__ + "img/breakdown-blue.d7cbebbe.svg";